import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="spg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#24385A" /><stop offset="1" stopColor="#17243A" /></linearGradient>
    </defs>
    <rect width="64" height="64" rx="16" fill="url(#spg)" />
    <path d="M40.5 21.5c-2.2-2.3-5.4-3.5-9-3.5-6 0-10 3.2-10 7.8 0 4.4 3.3 6.3 8.6 7.5 3.9.9 5.4 1.8 5.4 3.6 0 1.9-1.9 3.1-4.8 3.1-3.1 0-5.7-1.3-7.6-3.4l-3.6 4.1c2.6 2.8 6.6 4.4 11 4.4 6.6 0 10.9-3.4 10.9-8.4 0-4.6-3.2-6.6-8.9-7.8-3.7-.8-5.1-1.6-5.1-3.2 0-1.6 1.6-2.7 4.1-2.7 2.4 0 4.5.9 6 2.3z" fill="#fff" />
    <circle cx="47" cy="44" r="4.5" fill="#14B8A6" />
  </svg>
);

export default function Logo({ light = false, testId = "brand-logo-link" }) {
  return (
    <Link to="/" data-testid={testId} className="flex items-center gap-2.5 group rounded-lg" aria-label="SaaSPivora home">
      <LogoMark className={`h-9 w-9 rounded-[11px] transition-transform duration-300 group-hover:scale-[1.04] ${light ? "ring-1 ring-white/25" : "shadow-sm"}`} />
      <span className="font-display text-[21px] font-extrabold tracking-[-0.03em] leading-none" style={{ color: light ? "#fff" : "#17243A" }}>
        SaaS<span style={{ color: light ? "#8FD3C8" : "#3F5E7A" }}>Pivora</span>
      </span>
    </Link>
  );
}
